import apiFetch from '@wordpress/api-fetch';

/* global bseDataObject */

// Fetch settings from the API
export const fetchSettings = async () => {
	try {
		const response = await apiFetch( {
			path: '/suremails/v1/get-settings',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': bseDataObject.nonce,
			},
		} );

		if ( typeof response !== 'object' ) {
			throw new Error( 'Invalid JSON response' );
		}
		return response;
	} catch ( error ) {
		throw new Error( error.message || 'Error fetching settings' );
	}
};

// Save settings to the API
export const saveSettings = async ( updatedSettings ) => {
	try {
		const response = await apiFetch( {
			path: '/suremails/v1/set-settings',
			method: 'POST',
			headers: {
				'X-WP-Nonce': bseDataObject.nonce,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify( {
				settings: {
					delete_email_logs_after:
						updatedSettings.settings.delete_email_logs_after,
					log_emails: updatedSettings.settings.log_emails,
					email_simulation: updatedSettings.settings.email_simulation,
					default_connection:
						updatedSettings.settings.default_connection,
				},
			} ),
		} );
		return response;
	} catch ( error ) {
		throw new Error( error.message || 'Error saving settings' );
	}
};
